module.exports = __webpack_public_path__ + "img/Proteus_Home.5cf97571.png";